module.exports = __webpack_public_path__ + "img/red.bbcfde55.png";